import classnames from 'classnames';
import _ from 'lodash';
import Skeleton from 'react-loading-skeleton';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import MaxWidthContainer from 'components/MaxWidthContainer';
import StrapiImg from 'components/StrapiImg';
import WebpImg from 'components/WebpImg';
import useRWD from 'hooks/useRWD';
import { MixpanelConfig } from 'utils/mixpanelConfig';
const HomePromoBanner = (props) => {
  const { isLoading, banners } = props;
  const { isLg } = useRWD();

  const getNextBanner = (idx) => {
    const nextIndex = (idx + 1) % banners.length;
    return banners.length > 1 ? banners[nextIndex] : null;
  };

  const imageUrl = (banner) => {
    if (!banner?.images) return '';

    const primaryField = isLg ? 'image' : 'mobile_image';
    const fallbackField = isLg ? 'mobile_image' : 'image';

    return (
      _.find(banner.images, { field: primaryField })?.url ||
      _.find(banner.images, { field: fallbackField })?.url ||
      ''
    );
  };

  return (
    <>
      {(isLoading || banners.length > 0) && (
        <MaxWidthContainer
          key={isLg ? 'desktop' : 'mobile'}
          className="relative mt-4 flex justify-center overflow-hidden px-4 pb-6 lg:mt-16"
          noPending
        >
          <div
            className="relative"
            style={{
              width: isLg
                ? banners.length === 1
                  ? `765px`
                  : `${765 * 3 + 10 * 2}px`
                : '100%',
              '--swiper-pagination-color': '#4a4a4a',
              '--swiper-pagination-bullet-inactive-color': '#4a4a4a66',
              '--swiper-pagination-bottom': '-24px',
            }}
          >
            {isLoading ? (
              <Skeleton className="aspect-[343/193] h-auto w-full lg:aspect-auto lg:h-[261px]" />
            ) : (
              <Swiper
                initialSlide={1}
                className="w-full !overflow-visible pb-12"
                modules={[Navigation, Pagination, Autoplay]}
                loop={true}
                autoplay={{
                  delay: 3000,
                  // disableOnInteraction: true,
                  pauseOnMouseEnter: true,
                }}
                pagination={{
                  enabled: true,
                  clickable: true,
                }}
                spaceBetween={isLg ? 10 : 16}
                slidesPerView={isLg ? (banners.length === 1 ? 1 : 3) : 1}
                centeredSlides={isLg ? true : false}
              >
                {banners.map((banner, idx) => {
                  const nextBanner = getNextBanner(idx) || null;
                  const { id, images, url = null, new_tab = false } = banner;

                  return (
                    <SwiperSlide key={`${idx}-${id}`}>
                      {({ isActive }) => {
                        const shouldShowNext =
                          isLg && isActive && nextBanner && banners.length > 1;

                        return (
                          <div
                            style={
                              isLg
                                ? {
                                    width: '765px',
                                    height: '261px',
                                  }
                                : {
                                    width: '100%',
                                    aspectRatio: '343/193',
                                  }
                            }
                            className={classnames('relative bg-white', {
                              'pointer-events-none': !isActive,
                            })}
                          >
                            <a
                              href={!url ? '#' : url}
                              onClick={() => {
                                MixpanelConfig.track('Click', {
                                  Component: 'Home Page Ad',
                                  'Ad Name': banner.name || null,
                                  'Ad URL': banner.url || null,
                                });
                              }}
                              target={new_tab ? '_blank' : ''}
                            >
                              <div
                                className={classnames(
                                  'relative h-full w-full overflow-hidden rounded-lg bg-center transition-opacity',
                                  {
                                    'opacity-100': isActive,
                                    'opacity-50': !isActive,
                                  }
                                )}
                              >
                                <WebpImg
                                  className="h-full w-full object-cover"
                                  src={imageUrl(banner) || ''}
                                  alt={banner.name || 'Banner'}
                                />
                                {banner.id === 87 && (
                                  <StrapiImg
                                    className="h-px w-px"
                                    src="https://ad.doubleclick.net/ddm/trackimp/N1003017.4334518SORRAHKFACEBOOK/B32821884.407904241;dc_trk_aid=599933411;dc_trk_cid=225687372;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=$%7BGDPR%7D;gdpr_consent=$%7BGDPR_CONSENT_755%7D;ltd=;dc_tdv=1"
                                  />
                                )}
                              </div>
                            </a>

                            {shouldShowNext && (
                              <div
                                style={
                                  isLg
                                    ? {
                                        width: '765px',
                                        height: '261px',
                                      }
                                    : {
                                        width: '100%',
                                        aspectRatio: '343/193',
                                      }
                                }
                                className="absolute -right-4 top-0 translate-x-full bg-white lg:-right-2.5"
                              >
                                <div
                                  className={classnames(
                                    'relative h-full w-full overflow-hidden rounded-lg opacity-100 transition-opacity lg:opacity-50'
                                  )}
                                >
                                  <WebpImg
                                    className="h-full w-full object-cover"
                                    src={imageUrl(nextBanner) || ''}
                                    alt={nextBanner.name || 'Next Banner'}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      }}
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            )}
          </div>
          <div
            style={{
              background: `linear-gradient(to right, white 0%, transparent 10%), linear-gradient(to left, white 0%, transparent 10%)`,
            }}
            className="pointer-events-none absolute left-0 top-0 z-10 hidden h-full w-full lg:block"
          />
        </MaxWidthContainer>
      )}
    </>
  );
};

export default HomePromoBanner;
